import React, { useState } from "react";
import { CampaignViewDetailsViewPrimaryInfoProps } from "./campaign-view-details-view-primary-info.props";
import "./campaign-view-details-view-primary-info.scss";

const CampaignViewDetailsViewPrimaryInfo: React.FC<
  CampaignViewDetailsViewPrimaryInfoProps
> = (props: any) => {
  const { campaignDetails, viewPrimaryInfoOpen, setViewPrimaryInfoOpen } =
    props;
  // const handleEditOpen = () => setViewPrimaryInfoOpen(!viewPrimaryInfoOpen);

  return (
    <div className="campaign-list-view-details-view-box-primary-info">
      <div className="campaign-list-view-details-view-box-primary-info-other">
        <div className="campaign-list-view-details-view-box-primary-info-other-section">
          <div className="campaign-list-view-details-view-box-primary-info-other-section-main-text">
            Campaign Name
          </div>
          <div className="campaign-list-view-details-view-box-primary-info-other-section-sub-text" title={campaignDetails?.name}>
            {campaignDetails?.name || "-"}{" "}
          </div>
        </div>
        <div className="campaign-list-view-details-view-box-primary-info-other-section">
          <div className="campaign-list-view-details-view-box-primary-info-other-section-main-text">
            Campaign Owner
          </div>
          <div className="campaign-list-view-details-view-box-primary-info-other-section-sub-text">
            {campaignDetails?.campaignOwner?.first_name || ""}{" "}
            {campaignDetails?.campaignOwner?.last_name || ""}
          </div>
        </div>
        <div className="campaign-list-view-details-view-box-primary-info-other-section">
          <div className="campaign-list-view-details-view-box-primary-info-other-section-main-text">
            Type
          </div>
          <div className="campaign-list-view-details-view-box-primary-info-other-section-sub-text">
            {campaignDetails?.type || "-"}
          </div>
        </div>
        <div className="campaign-list-view-details-view-box-primary-info-other-section">
          <div className="campaign-list-view-details-view-box-primary-info-other-section-main-text">
            Status
          </div>
          <div className="campaign-list-view-details-view-box-primary-info-other-section-sub-text">
            {campaignDetails?.status || "-"}
          </div>
        </div>
        <div className="campaign-list-view-details-view-box-primary-info-other-section">
          <div className="campaign-list-view-details-view-box-primary-info-other-section-main-text">
            Actual Cost
          </div>
          <div className="campaign-list-view-details-view-box-primary-info-other-section-sub-text">
            {campaignDetails?.actual_cost
              ? `$ ${campaignDetails.actual_cost}`
              : "-"}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CampaignViewDetailsViewPrimaryInfo;
